import styled, { css } from 'styled-components';

type WrapperProps = {
    $clickable: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
    -webkit-font-smoothing: antialiased;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    text-align: right;
    letter-spacing: -0.02em;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.7);

    ${({ $clickable }) =>
        $clickable &&
        css`
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        `}
`;

export const NumberLabel = styled.span`
    color: white;
    margin-left: 2px;
    margin-right: 6px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        margin-right: 2px;
    }
`;
